<template>
  <section v-if="isShow">
    <div class="chat-bar-widget" :key="isRender">
      <div v-for="channel in chatBar" :key="channel.id" class="chat-bar-channel" :title="location(channel)" @click="showMessages(channel)">
        <span class="chat-badge-unread chat-bar-unread" v-show="channel.unreadCount > 0">{{ channel.unreadCount }}</span>
        <div>{{ title(channel) }}</div>
        <div class="chat-bar-desc">{{ vehicle(channel) }}</div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'chat-bar',
  data() {
    return {
      isRender: 0
    }
  },
  computed: {
    ...mapGetters('chat', ['chatBar', 'channels']),
    isShow() {
      let _is = false
      if (this.chatBar) {
        if (this.chatBar.length > 0) {
          _is = true
        }
      }
      return _is
    }
  },
  methods: {
    title(channel) {
      let title = ''
      if (channel) {
        if (channel.type === 'adhoc') {
          title = channel.name
        } else {
          if (channel.metadata) {
            if (channel.metadata.ronumber) {
              title = `#${channel.name} - RO ${channel.metadata.ronumber}`
            } else {
              title = `#${channel.name}`
            }
          }
        }
      }
      return title
    },
    location(channel) {
      let location = ''
      if (channel) {
        if (channel.metadata && channel.type === 'request') {
          location = channel.metadata.firmName
        }
      }
      return location
    },
    vehicle(channel) {
      let desc = ''
      if (channel) {
        if (channel.metadata && channel.type === 'request') {
          desc = `${channel.metadata.year} ${channel.metadata.make} ${channel.metadata.model}`
        }
      }
      return desc
    },
    refreshBar() {
      let $this = this
      setTimeout(() => {
        $this.isRender += 1
        $this.$forceUpdate()
      }, 200)
    },
    showMessages(channel) {
      this.$emit('showMessages', channel)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/elements/chat-bar.vue